import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { listCards } from '../../../actions/cardActions';
import { cardListReset } from '../../../reducers/cardReducers';
import CreditCard from '../CreditCard/CreditCard';
import CreateCCModal from '../CreditCard/CreateCCModal';
import Loader from '../../Loader';
import Message from '../../Message';
import { FaExclamationTriangle } from 'react-icons/fa';
import '../styles.css'; // Import the shared styles
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../actions/userActions';
import { COLORS } from '../../../constants/colors';

function CreditCardScreen() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        cardReducers: { error, loading, success, cards = [] }
    } = useSelector((state) => state);

    const [showCreateModal, setShowCreateModal] = useState(false);

    const createModalShow = () => setShowCreateModal(true);
    const createModalClose = () => setShowCreateModal(false);

    useEffect(() => {
        dispatch(listCards());
        return () => {
            dispatch(cardListReset());
        };
    }, [dispatch]);

    // Handle authentication error
    useEffect(() => {
        if (error && error.includes('Authentication credentials were not provided')) {
            // Log out the user and redirect to home page
            dispatch(logout());
            navigate('/');
        }
    }, [error, dispatch, navigate]);

    // Color palette for alerts and messages using the new color scheme
    const plum = COLORS.PLUM;
    const warmConcrete = COLORS.WARM_CONCRETE;

    return (
        <>
            {loading ? (
                <Loader />
            ) : error && !error.includes('Authentication credentials were not provided') ? (
                <Message variant='danger'>{error}</Message>
            ) : (
                <>
                    <Row className='mx-3'>
                        <Col md={4} className='h5' style={{cursor: 'pointer'}} onClick={createModalShow}>
                            <i className="fa-solid fa-plus" /> &nbsp; <span className='h5'>Add a bank card</span>
                        </Col>
                    </Row>
                    <Row className='mx-3'>
                        <Col className='d-flex justify-content-center mb-4'>
                            <hr className='divider'/>
                        </Col>
                    </Row>
                    <Row className='mx-3'>
                        {Array.isArray(cards) && cards.length > 0 ? (
                            cards.map(card => (
                                <Col key={card._id} sm="12" md="6" lg="6" xl="6" className='border rounded mb-3 me-3'>
                                    <CreditCard card={card} loading={loading} success={success} />
                                </Col>
                            ))
                        ) : (
                            <Col className="mt-4">
                                <Alert 
                                    className="mb-0 py-2 text-center" 
                                    style={{ 
                                        backgroundColor: warmConcrete, 
                                        color: plum,
                                        borderRadius: 4, 
                                        border: `1px solid ${plum}`,
                                        transition: 'background-color 0.5s ease, color 0.5s ease'
                                    }}
                                >
                                    <div className="d-flex align-items-center justify-content-center">
                                        <FaExclamationTriangle className="me-2" style={{ fontSize: '1.5rem' }} />
                                        <strong>No bank cards found. Add your first card to be able to place a bid.</strong>
                                    </div>
                                </Alert>
                            </Col>
                        )}
                    </Row>
                </>
            )}
            <CreateCCModal 
                show={showCreateModal}
                onHide={createModalClose}
                dispatch={dispatch}
                loading={loading}
            />
        </>
    );
}

export default CreditCardScreen;